import React from 'react';

import { ValueStub } from 'constants/data';
import { alwaysTrue } from 'utils/data';

import { TableCellId, tableCellWidthMap } from './DocumentExpirationDates.constants';
import { renderDateCellContent } from './DocumentExpirationDates.utils';
import RowActionButton from './RowActionButton';

export const getTableConfig = ({ setDataToEdit, isEditMode }) => ({
  [TableCellId.TITLE]: {
    label: 'Title',
    width: tableCellWidthMap[TableCellId.TITLE],
    sort: true,
    fieldName: 'Title',
    colSpan: ({ [TableCellId.TITLE]: cellData }) => cellData?.colSpan,
    customStyles: ({ [TableCellId.TITLE]: cellData }) => cellData?.customStyles,
    renderContentAsText: ({ [TableCellId.TITLE]: cellData }) => !cellData?.content,
    content: ({ [TableCellId.TITLE]: cellData }) => cellData?.content ?? cellData,
  },
  [TableCellId.START_DATE]: {
    align: 'center',
    label: 'Start Date',
    width: tableCellWidthMap[TableCellId.START_DATE],
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.START_DATE]: cellData }) => renderDateCellContent(cellData),
  },
  [TableCellId.EXPIRES_IN_DAYS]: {
    align: 'center',
    label: 'Expires in x days',
    width: tableCellWidthMap[TableCellId.EXPIRES_IN_DAYS],
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.EXPIRES_IN_DAYS]: cellData }) => cellData || ValueStub.ALTERNATE,
  },
  [TableCellId.EXPIRATION_DATE]: {
    align: 'center',
    label: 'Expiration Date',
    width: tableCellWidthMap[TableCellId.EXPIRATION_DATE],
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ [TableCellId.EXPIRATION_DATE]: cellData }) => renderDateCellContent(cellData),
  },
  [TableCellId.ACTION]: {
    align: 'center',
    label: 'Action',
    width: tableCellWidthMap[TableCellId.ACTION],
    content: ({ [TableCellId.ACTION]: cellData, ...rowData }) => (
      <RowActionButton isEditMode={isEditMode} rowData={rowData} setDataToEdit={setDataToEdit} />
    ),
  },
});
